import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import DocumentUploadForm from "@/components/DocumentUploadForm";
import UnsavedChangesDialog from "@/components/UnsavedChangesDialog";
import { useUnsavedChangesGuard } from "@/hooks/useUnsavedChangesGuard";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  lockedOwnership?: string;
}

const UploadDocument = ({ open, onOpenChange, lockedOwnership }: Props) => {
  const [dirty, setDirty] = useState(false);
  const { isBlocked, confirmLeave, cancelLeave, guardedNavigate } = useUnsavedChangesGuard(dirty);

  return (
    <>
      <Dialog
        open={open}
        onOpenChange={(next) => {
          if (!next) {
            guardedNavigate(() => onOpenChange(false));
          } else {
            onOpenChange(next);
          }
        }}
      >
        <DialogContent className="sm:max-w-[640px] max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="text-lg font-bold">Upload Document</DialogTitle>
          </DialogHeader>
          <DocumentUploadForm
            onComplete={() => onOpenChange(false)}
            lockedOwnership={lockedOwnership}
            onDirtyChange={setDirty}
          />
        </DialogContent>
      </Dialog>
      <UnsavedChangesDialog open={isBlocked} onConfirm={confirmLeave} onCancel={cancelLeave} />
    </>
  );
};

export default UploadDocument;
